import type { Metadata } from "next";
import { Geist, Geist_Mono } from "next/font/google";
import "./globals.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { WikiMapProvider } from "@/contexts/WikiMapContext";
import SearchModal from "@/components/SearchModal";
import VoiceCommandProvider from "@/components/VoiceCommandProvider";
import { VoiceCommandContextProvider } from "@/contexts/VoiceCommandContext";
import ServiceWorkerRegistrar from "@/components/ServiceWorkerRegistrar";
import { Toaster } from "sonner";
import ConfirmDialog from "@/components/ConfirmDialog";
import ConnectionBanner from "@/components/ConnectionBanner";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export const metadata: Metadata = {
  title: "InsuWiki - 보험 지식 공유 플랫폼",
  description: "보험 전문가를 위한 지식 공유 Wiki 플랫폼",
  manifest: "/manifest.json",
  appleWebApp: {
    capable: true,
    statusBarStyle: "default",
    title: "InsuWiki",
  },
  formatDetection: {
    telephone: false,
  },
  icons: {
    icon: "/icon.svg",
    apple: "/icon.svg",
  },
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="ko">
      <body
        className={`${geistSans.variable} ${geistMono.variable} antialiased`}
      >
        <AuthProvider>
          <WikiMapProvider>
            <VoiceCommandContextProvider>
              {children}
              <SearchModal />
              <VoiceCommandProvider />
              <ServiceWorkerRegistrar />
              <ConnectionBanner />
              <Toaster position="top-center" richColors closeButton duration={3000} />
              <ConfirmDialog />
            </VoiceCommandContextProvider>
          </WikiMapProvider>
        </AuthProvider>
      </body>
    </html>
  );
}
